import { Link } from "react-router-dom";
import "./AnnouncementBar.css";

const AnnouncementBar = ({ onClose }) => {
  return (
    <div className="announcement_bar">
      <Link
        to="/news/our-new-ai-hub-is-officially-live-in-coimbatore"
        className="announcement_link"
      >
        Big News: Our New AI Hub is Officially Live!
      </Link>

      <button
        className="announcement_close"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          if (onClose) onClose();
        }}
      >
        ✕
      </button>
    </div>
  );
};

export default AnnouncementBar;
